import { createFileRoute } from "@tanstack/react-router";
import { comingSoonPage } from "@/components/ComingSoon";
import { requireAuth } from "@/lib/auth-guard";

/**
 * Friends — mirrors iOS FriendsScreen. Friend circles are v2 API:
 * GET/POST /api/v2/friend-circles · PATCH /api/v2/friend-circles/{id}
 * (name/sharingPolicy) · POST .../merge · DELETE (blocked while sole
 * container of a friend) · GET /api/v2/friends ·
 * PUT /api/v2/friends/{id}/circles · DELETE /api/v2/friends/{id} ·
 * GET /api/v2/friends/invites.
 * Rules: circle names are private to the owner; deselecting all
 * circles severs the friendship both ways; minors' friendships gate
 * on guardian approval; circle cap 402 feature_gated.
 */
export const Route = createFileRoute("/friends")({
  loader: ({ context }) => requireAuth(context.queryClient),
  component: comingSoonPage(
    "Friends",
    "Your friend circles — share memories with friends, in circles only you can see. We're building this surface now.",
  ),
});
